import { validateProps } from '../../utils';
import { isValidBase } from '../BaseEntity';
import { isValidContact } from '../Contact';
export let SchedulingAction = /*#__PURE__*/function (SchedulingAction) {
  SchedulingAction["UNKNOWN"] = "UNKNOWN";
  SchedulingAction["SCHEDULE"] = "SCHEDULE";
  SchedulingAction["RESCHEDULE"] = "RESCHEDULE";
  SchedulingAction["CANCEL"] = "CANCEL";
  return SchedulingAction;
}({});
export const isValidEnrichedAction = properties => {
  const ans = isValidBase(properties) && validateProps(properties, ['schedulingAction', 'taskDescription', 'participants']) && properties.participants.every(_ref => {
    let {
      contact
    } = _ref;
    return isValidContact(contact);
  });
  return ans;
};
//# sourceMappingURL=EnrichedAction.js.map